import { webSocketApiUrlsDictionary } from '../constants';

export async function generateTerminalQRArtPNG({
  primaryColor,
  qrValue,
  stationCode,
  chargeBoxId,
}: {
  primaryColor: string;
  qrValue: string;
  stationCode: string;
  chargeBoxId: string;
}) {
  const token = localStorage.getItem('auth-token');
  const apiKey = localStorage.getItem('api-key');
  const theme = localStorage.getItem('theme');
  const baseUrl =
    webSocketApiUrlsDictionary[theme]?.apiUrl ||
    process.env.REACT_APP_API_URL ||
    `${window.location.origin}/api/v1/`;

  const response = await fetch(`${baseUrl}chargepoints/qr-art`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': 'pt-BR',
      Platform: 'DASHBOARD',
      'Api-Key': apiKey ?? '',
      ...(token && { Authorization: token }),
    },
    body: JSON.stringify({
      template: 'terminal',
      qrValueUrl: qrValue,
      primaryColor,
      stationCode,
      chargeBoxId,
    }),
  });

  if (!response.ok) {
    const errorBody = await response.text().catch(() => '');
    console.error('[generateTerminalQRArtPNG] status:', response.status, errorBody);
    throw new Error(`Erro ao gerar PDF (${response.status})`);
  }

  const blob = await response.blob();
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `Arte-QR-Terminal-${chargeBoxId}.pdf`;
  link.click();
  URL.revokeObjectURL(link.href);
}
